import './App.css';
import HomePage from './Component/HomePage/HomePage';
import About from './Component/About/About';
import Skills from './Component/Skills/Skills';
import MyWork from './Component/MyWork/MyWork';
import Contact from './Component/Contact/Contact';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import NavBar from './Component/NavBar/NavBar';
import { useState, useEffect } from 'react';
import Login from './Component/Login/Login';
import AboutDet from './Component/Logged_In/About/About';
import SkillDet from './Component/Logged_In/Skill/Skill';
import HomePageDet from './Component/Logged_In/HomePage/HomePage';
import ContactDet from './Component/Logged_In/Contact/Contact';
import LoginDet from './Component/Logged_In/Login/Login';
import MyWorkDet from './Component/Logged_In/MyWork/MyWork';
import axios from 'axios';
import { useSelector } from 'react-redux';

// import SocketClient from 'socket.io-client';

function App() {

  const [loading, setloading] = useState(false);
  const [currentTime, setcurrentTime] = useState(null);
  const [currentDate, setcurrentDate] = useState(null);
  const [sideBar, setsideBar] = useState(false);
  const [popupdata, setpopopupData] = useState([]);
  const [popupdataLoaded, setpopopupDataLoaded] = useState(false);
  const popUpFetchUrl = 'https://my-webpage-node.vercel.app/HomePage/popups';
  const [closeClassName, setcloseClassName] = useState('far fa-times-circle');
  const localStorageData = useSelector((state) => state.Reducer);

  setInterval(() => {
    let timee = new Date();
    let val1 = '';
    let val2 = '';
    val1 = timee.getHours().toString().length === 1 ? '0' + timee.getHours().toString() : timee.getHours().toString();
    val1 += ' : ';
    val1 += timee.getMinutes().toString().length === 1 ? '0' + timee.getMinutes().toString() : timee.getMinutes().toString();
    val1 += ' : ';
    val1 += timee.getSeconds().toString().length === 1 ? '0' + timee.getSeconds().toString() : timee.getSeconds().toString();
    val2 += timee.getDate().toString().length === 1 ? '0' + timee.getDate().toString() : timee.getDate().toString();
    val2 += ' - ';
    val2 += timee.toDateString().split(' ')[1];
    val2 += ' - ';
    val2 += timee.getFullYear().toString();
    setcurrentTime(val1)
    setcurrentDate(val2)
  }, 0)

  useEffect(() => {
    setloading(true);
    async function getpopUpData() {
      await axios.get(popUpFetchUrl).then((e) => {
        setpopopupData(e.data);
        setpopopupDataLoaded(true);
      }).catch((e) => {
        console.log(e);
      })
    }
    getpopUpData();
  }, []);

  return (<>
    <div className='PageDivision'>
      <BrowserRouter>
        <div className='NavDivision'>
          {loading ? <NavBar /> : ''}
        </div>
        <div className={sideBar ? 'NavBarMobDivClicked' : 'NavBarMobDiv'}>
          <i className={sideBar ? 'fas fa-bars navBarOptionsClicked' : 'fas fa-bars navBarOptions'} onClick={() => {
            sideBar ? setsideBar(false) : setsideBar(true);
          }}></i>
        </div>
        {sideBar ? <>
          <div className='navBarSideBarDivision'>
            <NavBar btnPrsd={sideBar} clickedBtn={(e) => {
              if (e) {
                setsideBar(false)
              }
            }} />
          </div>
        </> : ''}
        <div className={sideBar ? 'ContentMainDivHidden' : 'ContentMainDiv'}>
          <Switch>
            <Route path='/' exact component={HomePage} />
            <Route path='/About' component={About} />
            <Route path='/Skills' component={Skills} />
            <Route path='/MyWork' component={MyWork} />
            <Route path='/Contact' component={Contact} />
            <Route path='/Login' component={Login} />
            <Route path='/Shan/About' component={AboutDet} />
            <Route path='/Shan/Skill' component={SkillDet} />
            <Route path='/Shan/HomePage' component={HomePageDet} />
            <Route path='/Shan/Contact' component={ContactDet} />
            <Route path='/Shan/MyWork' component={MyWorkDet} />
            <Route path='/Shan/Login' component={LoginDet} />
            <Route component={() => {
              return (<>
                <div style={{ color: 'white' }}>Forbidden URL</div>
              </>)
            }} />
          </Switch>
          <div className='TimeDatalogo'>
            <div className='TimeLogo'>Time : {currentTime}</div>
            <div className='yearLogo'>Date : {currentDate}</div>
          </div>
          {popupdataLoaded && (localStorageData.HomePage.SelectedPage === 0) ? <>
            {popupdata.map((ite, index) => {
              if (ite?.popuppage === 'HomePage' && ite?.showpopup) {
                return (<>
                  <div className='popUpDivisionAbs'>
                    <div className='imageDisplayPopUpAbs'>
                      <img className='imageDisplayPopUpAbsimg' src={ite?.popuplink} alt={ite.popuplink} />
                      <i className={closeClassName + ' popUpCloseWindowimgDiv'} onMouseEnter={() => {
                        setcloseClassName('fas fa-times-circle');
                      }} onMouseLeave={() => {
                        setcloseClassName('far fa-times-circle');
                      }} onClick={() => {
                        setpopopupDataLoaded(false);
                      }}></i>
                    </div>
                  </div>
                </>);
              } else {
                return (<></>);
              }
            })}
          </> : ''}
        </div>
      </BrowserRouter>
    </div>
  </>);
}

export default App;

// export const socketIO = SocketClient('http://localhost:8080/', { transports: ['websocket'] })
// socketIO.on('connect', () => {
// console.log('connected')
// })
// socketIO.on('ClientId', (data) => {
//   console.log('Client Id', data)
// })